import HeroSection from '../HeroSection';
import DashboardShowcase from '../DashboardShowcase';
import PlatformFunctionalities from '../PlatformFunctionalities';
import PricingSection from '../PricingSection';
import AIIntegration from '../AIIntegration';
import ShortUseCasesSection from '../ShortUseCasesSection';
import AIMeshShowcase from '../AIMeshShowcase';

const IndexPage = () => (
  <div className="page-content">
    <HeroSection />
    <ShortUseCasesSection />
    <DashboardShowcase />
    <PlatformFunctionalities />
    <AIMeshShowcase />
    <PricingSection />
    <AIIntegration title='Harness the Power of an AI Enabled Platform' description='Our advanced AI-driven microservices enriches your platform experiences, detects hidden patterns, automates workflows and delivers actionable insights in real time—empowering you to make smarter, faster decisions.' />
  </div>
);

export default IndexPage;
